import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-select-smart-sms-request-id',
    templateUrl: 'get-smart-sms-request-id.html',
    standalone: false
})
  export class GetSmartSendRequestIdDialog {
    requestId:string = '';

    requestDataForm=new FormGroup({
      "requestId":new FormControl('',Validators.required)
  });
    constructor(
        public dialogRef: MatDialogRef<GetSmartSendRequestIdDialog>,
      ) {}

    onNoClick(): void {
        this.dialogRef.close(-1);
      }

    getRequestId(){
        if(this.requestId=='') return -1;
        return Number.parseInt(this.requestId);
    }
    onClose(){
      this.dialogRef.close(-1);
    }
  }